var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"willOverview"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('BrokerReportPlansCard')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }